import { Container, Form, Title, Input } from "./style";
import { Error } from "../../styles/global";
import Email from "../../components/Email";
import Button from "../../components/Button";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./validations";
import HiddenInputs from "../../components/HiddenInputs";
import TagManager from "react-gtm-module";
import { InputContainer } from "../PersonalData/style";

const SubmitForm = ({ email, setEmail, formId }) => {
  const randomId = `${Date.now()}${Math.random()
    .toString(36)
    .substring(2)}`.slice(0, 20);
  sessionStorage.setItem("transactionId", randomId);
  const { register, errors, setError, clearErrors, watch } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
  });

  const url = "https://kenzie39049.activehosted.com/proc.php";

  const aboutYou = watch(["field[48]"])["field[48]"];
  const paymentMethod = watch(["field[222]"])["field[222]"];

  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const submitData = (e) => {
    if (
      email === "" ||
      aboutYou === "" ||
      paymentMethod === "" ||
      validateEmail.test(email) === false
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: "Preencha esse campo obrigatório." });
      }

      if (aboutYou === "") {
        setError("aboutYou", { message: "Preencha esse campo obrigatório." });
      }

      if (paymentMethod === "") {
        setError("paymentMethod", {
          message: "Preencha esse campo obrigatório.",
        });
      }

      return false;
    }
    localStorage.setItem("lomadee_id", randomId);
    localStorage.setItem("email", email);
    return true;
  };

  useEffect(() => {
    if (aboutYou !== "") {
      clearErrors("aboutYou");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aboutYou]);

  useEffect(() => {
    if (paymentMethod !== "") {
      clearErrors("paymentMethod");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <>
      <Container id="main">
        <Form onSubmit={submitData} method="POST" action={url} validate>
          <HiddenInputs formId={formId} />

          <Email
            inputRef={register}
            name="email"
            error={errors.email?.message}
            value={email}
            onChange={setEmail}
          />

          <Title>Conte um pouco mais sobre você</Title>

          <Input>
            <label>
              Conte para nós, em no mínimo 100 palavras, o porque deseja se
              tornar um(a) programador(a).
            </label>

            <textarea ref={register} name="field[48]" />

            <Error>{errors.aboutYou?.message}</Error>
          </Input>

          <Input>
            <label>Qual mensagem você gostaria de deixar para nós?</label>

            <textarea ref={register} name="field[49]" />
          </Input>

          <InputContainer>
            <Input>
              <label>Como deseja pagar o curso?</label>
              <select ref={register} name="field[222]">
                <option value="">Selecione</option>
                <option value="Financiado (Carência)">
                  Financiado (R$24.000 | 5% entrada + até 36x após 12 meses)
                </option>
                <option value="À Vista">
                  À Vista (R$17.600 - 20% de desconto)
                </option>
                <option value="Parcelado">
                  Parcelado (R$21.600 | 12x de R$1.800 com 10% de desconto)
                </option>
              </select>
              <Error>{errors.paymentMethod?.message}</Error>
            </Input>
          </InputContainer>

          <input type="hidden" name="field[186]" value={randomId} />

          <Button>Enviar Minha Inscrição</Button>
        </Form>
      </Container>
    </>
  );
};

export default SubmitForm;
